import { IconButton } from '@loomhq/lens';
import cx from 'classnames';
import throttle from 'lodash/throttle';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createReaction } from 'creators/videoPlayer';

import useMedia from 'hooks/useMedia';
import { selectPlayerTime } from 'selectors/videoPlayer';

import { emojiTypeToPath } from 'components/ui-components/emoji';

import styles from './styles.module.less';

const EMOJI_BUTTON_SMASHING_DELAY = 500;

const EmojiIconButton = props => {
  const {
    type,
    onClick,
    disabled,
    size,
    fromEndScreen,
    forceSmallIcon,
  } = props;
  const dispatch = useDispatch();

  const currentTime = useSelector(selectPlayerTime);

  const fullSize = useMedia(['(min-width: 560px)'], [true], false);
  let responsiveSize = fullSize ? 'medium' : 'small';

  if (forceSmallIcon) {
    responsiveSize = 'small';
  }

  const onClickEmoji = () => {
    dispatch(
      createReaction({
        type,
        time: currentTime * 1000,
        fromEndScreen,
      })
    );

    onClick && onClick();
  };

  return (
    <IconButton
      altText={type}
      isDisabled={disabled}
      icon={
        <img
          className={cx({ [styles.disabledIcon]: disabled })}
          src={emojiTypeToPath[type]}
        />
      }
      key={type}
      onClick={throttle(onClickEmoji, EMOJI_BUTTON_SMASHING_DELAY)}
      size={size || responsiveSize}
      type={type}
      data-testid={`${type}-reaction-button`}
    />
  );
};

export default EmojiIconButton;
